<div class="modal-content">
  <div class="modal-header">
    <h1 class="modal-title pull-left" aria-hidden="true">{{ 'HEALTH_PLAN_CANCEL_POPUP_TEXT1' | globalTranslate }}</h1>
    <button type="button" class="btn-close pull-right" [attr.aria-label]="'CLOSE' | globalTranslate" (click)="onCancel()">
      <img src="../../assets/images/⚛️ icons-close-circle-outline.svg" alt="close-icon" />
    </button>
  </div>
  <div class="modal-body">
    <h2 class="page-header sr-only" role="heading" aria-level="1">{{ 'HEALTH_PLAN_CANCEL_POPUP_TEXT1' | globalTranslate }}</h2>
    <p class="pb-2 pt-2">{{'HEALTH_PLAN_CANCEL_POPUP_TEXT2_PART1' | globalTranslate}} {{healthPlanDetails.requestSubmittedDate}}.</p>
  </div>
</div>